"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalContext = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var actions_1 = require("../../actions/actions");
var Filters_1 = __importDefault(require("../Filters/Filters"));
var Leaderboard_1 = __importDefault(require("../Leaderboard"));
var App_styled_1 = require("./App.styled");
var contextDefaultValue = {
    config: {
        logged_in: false,
        rate_video: false,
        is_admin: false,
        rank: '',
        instructor_id: '',
        access_level: '',
    },
    belts: [],
    students: [],
    regions: [],
};
exports.GlobalContext = react_1.createContext(contextDefaultValue);
var App = function () {
    var _a = react_1.useState(contextDefaultValue.config), config = _a[0], setConfig = _a[1];
    var _b = react_1.useState([]), belts = _b[0], setBelts = _b[1];
    var _c = react_1.useState([]), students = _c[0], setStudents = _c[1];
    var _d = react_1.useState([]), regions = _d[0], setRegions = _d[1];
    var refresh = function () {
        actions_1.fetchConfig().then(function (resp) {
            setConfig(resp.config);
            setBelts(resp.belts);
            setStudents(resp.students);
            setRegions(resp.regions);
        });
    };
    var updateStudents = function (students) {
        setStudents(students);
    };
    react_1.useEffect(function () {
        refresh();
    }, []);
    return (react_1.default.createElement(exports.GlobalContext.Provider, { value: {
            config: config,
            belts: belts,
            students: students,
            regions: regions,
            updateStudents: updateStudents,
        } },
        react_1.default.createElement(react_bootstrap_1.Container, { fluid: true },
            react_1.default.createElement(App_styled_1.StyledH1, { className: "single-title entry-title" }, "Leader Board"),
            react_1.default.createElement(Filters_1.default, null),
            react_1.default.createElement(Leaderboard_1.default, null))));
};
exports.default = App;
